<template>
  <div class="app-main-content provision-rule-config">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
        <el-tab-pane :lazy="true" label="岗位规则配置" name="positionRule" style="width:100%;height: 100%">
          <position-rule-tab ref="positionRule" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="人员特殊规则" name="personRule" style="width:100%;height: 100%">
          <person-rule-tab ref="personRule" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="人员组管理" name="personGroup" style="width:100%;height: 100%">
          <person-group-tab ref="personGroup" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="人员成本配置" name="personCost" style="width:100%;height: 100%">
          <person-cost-tab ref="personCost" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PositionRuleTab from './tabPane/positionRuleTab.vue'
import PersonRuleTab from './tabPane/personRuleTab.vue'
import PersonGroupTab from './tabPane/personGroupTab.vue'
import PersonCostTab from './tabPane/personCostTab.vue'

export default {
  name: 'ProvisionRuleConfig',
  components: { PositionRuleTab, PersonRuleTab, PersonGroupTab, PersonCostTab },
  data() {
    return {
      activeTabName: 'positionRule'
    }
  },
  mounted() {
    this.$nextTick(() => {
      const ref = this.$refs[this.activeTabName]
      if (ref && ref.init) ref.init()
    })
  },
  methods: {
    handleClick() {
      this.$nextTick(() => {
        const ref = this.$refs[this.activeTabName]
        if (ref && ref.init) ref.init()
      })
    }
  }
}
</script>

<style scoped>
.provision-rule-config {
  padding: 10px;
}
</style>
